import {
  Box,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useContext, useState } from "react";

import classNames from "classnames";

import { AlertPopup } from "components/AlertPopup";
import { apiClient } from "api";
import I18nKey from "translations/I18nKey";
import SimpleButton from "components/SimpleButton";
import { MOBILE_SCREEN_WIDTH } from "constants/constants";
import { useProductsStyles } from "../ProductStyles";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { TourContext } from "contexts/TourContext";
import { ProductSubscription } from "api/types";
import { AppState } from "store/types";
function ProductsBox(changeWidthProp: any) {
  const isMobile = useMediaQuery(MOBILE_SCREEN_WIDTH);
  const intl = useIntl();
  const productList = [
    {
      title: intl.formatMessage({
        id: I18nKey.PRICING_TITLE_MONTH,
      }),
      subTitle: "19.99",
      content: (
        <FormattedMessage
          id={I18nKey.PRICING_CONTENT_MONTH}
          values={{
            strong: (chunks) => <strong>{chunks}</strong>,
          }}
        />
      ),
      type: "monthly",
    },
    {
      title: intl.formatMessage({
        id: I18nKey.PRICING_TITLE_QUARTER,
      }),
      subTitle: "14.99",
      content: (
        <FormattedMessage
          id={I18nKey.PRICING_CONTENT_QUARTER}
          values={{
            strong: (chunks) => <strong>{chunks}</strong>,
            em: (chunks) => <em>{chunks}</em>,
          }}
        />
      ),
      type: "quarterly",
    },
    {
      title: intl.formatMessage({
        id: I18nKey.PRICING_TITLE_YEAR,
      }),
      subTitle: "9.99",
      content: (
        <FormattedMessage
          id={I18nKey.PRICING_CONTENT_YEAR}
          values={{
            strong: (chunks) => <strong>{chunks}</strong>,
            em: (chunks) => <em>{chunks}</em>,
          }}
        />
      ),
      type: "yearly",
    },
    {
      title: intl.formatMessage({
        id: I18nKey.PRICING_TITLE_AUTOPAY,
      }),
      subTitle: "9.99",
      content: (
        <FormattedMessage
          id={I18nKey.PRICING_CONTENT_AUTOPAY}
          values={{
            strong: (chunks) => <strong>{chunks}</strong>,
            em: (chunks) => <em>{chunks}</em>,
          }}
        />
      ),
      type: "auto_subscribe",
      info: intl.formatMessage({
        id: I18nKey.PRICING_CONTENT_AUTOPAY_INFO,
      }),
    },
  ];
  const [errMsg, setErrMsg] = useState<string>("");
  const [isLoadingArr, setIsLoadingArr] = useState(
    new Array(productList.length).fill(false)
  );
  const [isDisabledArr, setIsDisabledArr] = useState(
    new Array(productList.length).fill(false)
  );
  const classes = useProductsStyles();
  const token = useSelector((state: AppState) => state.auth.token);
  const { handleOpenSignUpModal, handleCloseProductsModal } =
    useContext(TourContext);
  const handleProductBuy = (type: string, index: number) => {
    setErrMsg("");
    if (token) handleProductSubscription(type, index);
    else {
      handleOpenSignUpModal(true);
    }
  };

  const handleProductSubscription = async (type: string, index: number) => {
    const updatedLoadingArr = [...isLoadingArr];
    const updatedDisableArr = [...isDisabledArr];
    updatedDisableArr.fill(true);
    updatedDisableArr[index] = false;
    updatedLoadingArr[index] = true;
    setIsDisabledArr(updatedDisableArr);
    setIsLoadingArr(updatedLoadingArr);
    const subscriptionParams = { product_type: type };
    return await apiClient
      .productSubscription(subscriptionParams)
      .then((res: ProductSubscription) => {
        if (res.data?.url) {
          window.location.replace(res?.data?.url);
        } else if (res.errors) {
          setErrMsg(res.errors[0]);
        }
      })
      .catch((err) => {
        setErrMsg(err);
      })
      .finally(() => {
        updatedLoadingArr[index] = false;
        setIsLoadingArr(updatedLoadingArr);
      });
  };

  return (
    <>
      <Box sx={{ padding: "20px", marginTop: isMobile ? "50px" : null }}>
        <Box
          className={classNames(classes.modalHeader, {
            modalHeaderMargin: changeWidthProp.changeWidthProp,
            mobile: isMobile,
          })}
        >
          <Typography
            className={classNames(classes.planTitle, {
              planTitleLandingPage: changeWidthProp.changeWidthProp,
            })}
          >
            {intl.formatMessage({
              id: I18nKey.PRICING_PLAN_TITLE,
            })}
          </Typography>
          <Typography
            className={classNames(classes.planSubTitle, {
              planSubTitleLandingPage: changeWidthProp.changeWidthProp,
            })}
          >
            {intl.formatMessage({
              id: I18nKey.PRICING_PLAN_SUBTITLE,
            })}
          </Typography>
        </Box>
        <Grid
          container
          className={classNames(classes.productContainer, {
            productGridHeight: changeWidthProp.changeWidthProp && !isMobile,
          })}
        >
          {productList.map((e, i) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              lg={3}
              className={classNames(classes.card, {
                changeWidth: changeWidthProp.changeWidthProp,
              })}
            >
              <Card className={classes.description}>
                <CardContent
                  className={classNames(classes.content, {
                    changeWidth: changeWidthProp.changeWidthProp,
                  })}
                >
                  <Box
                    className={classNames(classes.cardTitle, {
                      threeMonths: i === 1,
                      oneYear: i === 2,
                      autoPay: i === 3,
                    })}
                  >
                    <h3>{e.title}</h3>
                  </Box>
                  {i === 2 && (
                    <Typography
                      className={classNames(classes.bestSeller, {
                        mobile: isMobile,
                      })}
                    >
                      {intl.formatMessage({
                        id: I18nKey.PRICING_BEST_SELLER,
                      })}
                    </Typography>
                  )}
                  <Typography
                    className={classNames(classes.cardSubtitle, {
                      threeMonths: i === 1,
                      oneYear: i === 2,
                      autoPay: i === 3,
                      subTitleMargin: i === 0 || i === 1 || i === 3,
                    })}
                  >
                    <sup>$</sup>
                    {e.subTitle}{" "}
                    {e.type !== "monthly" ? (
                      <Typography className={classes.monthlyText}>
                        {intl.formatMessage({
                          id: I18nKey.PER_MONTH,
                        })}
                      </Typography>
                    ) : (
                      <Typography className={classes.monthlyText}>
                        &nbsp;
                      </Typography>
                    )}
                  </Typography>
                  <Box
                    className={classNames(classes.listItemContent, {
                      threeMonths: i === 1,
                      oneYear: i === 2,
                      autoPay: i === 3,
                    })}
                  >
                    <Typography>{e?.content}</Typography>
                  </Box>
                </CardContent>
                {changeWidthProp.changeWidthProp ? null : (
                  <CardActions className={classes.footer}>
                    <SimpleButton
                      text={intl.formatMessage({
                        id: I18nKey.PRICING_PLAN_BUYBTN,
                      })}
                      primary
                      className={classNames(classes.buyBtn, {
                        oneYear: i === 2,
                        autoPay: i === 3,
                      })}
                      loading={isLoadingArr[i]}
                      disable={isDisabledArr[i]}
                      onClick={() => handleProductBuy(e.type, i)}
                    />
                    {e.info && (
                      <Typography className={classes.info}>{e.info}</Typography>
                    )}
                  </CardActions>
                )}
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box className={classNames(classes.alertBox)}>
          {errMsg && (
            <AlertPopup
              loading={false}
              alertMsg={errMsg}
              styles={{
                height: "30px",
                position: isMobile ? "fixed" : "relative",
                top: isMobile ? "90% " : "auto",
                right: "auto",
                zIndex: "9999",
              }}
            />
          )}
        </Box>
      </Box>
    </>
  );
}

export default ProductsBox;
